import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';

const CustomLogin = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isNewPasswordRequired, setIsNewPasswordRequired] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state
  const history = useHistory();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setLoading(true);

    try {
      const cognitoUser = await Auth.signIn(username, password);

      if (cognitoUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
        setUser(cognitoUser); // Store the user for password change
        setIsNewPasswordRequired(true); // Switch to password change UI
      } else {
        const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();
        onLogin(token);
        history.push('/dashboard');
      }
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false); // Stop loading after the process
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setLoading(true);

    try {
      await Auth.completeNewPassword(user, newPassword);
      setIsNewPasswordRequired(false);
      setUser(null);
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false); // Stop loading after the process
    }
  };

  return (
    <div className="container mx-auto mt-8">
      <div className="max-w-md mx-auto">
        <h2 className="text-2xl font-bold mb-4">
          {isNewPasswordRequired ? 'Set New Password' : 'Sign In'}
        </h2>
        <form
          onSubmit={isNewPasswordRequired ? handleChangePassword : handleLogin}
          className="space-y-4"
        >
          {!isNewPasswordRequired && (
            <>
              <div>
                <label htmlFor="username" className="block text-sm font-medium text-gray-700">
                  Username
                </label>
                <input
                  type="text"
                  id="username"
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </>
          )}

          {isNewPasswordRequired && (
            <div>
              <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700">
                New Password
              </label>
              <input
                type="password"
                id="newPassword"
                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
          )}

          {errorMessage && <p className="text-red-500">{errorMessage}</p>}

          <button
            type="submit"
            className={`mt-4 w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white 
              ${loading ? 'bg-gray-500 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'}
              focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
            disabled={loading} // Disable button while loading
          >
            {loading ? (
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                ></path>
              </svg>
            ) : (
              isNewPasswordRequired ? 'Change Password' : 'Sign In'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CustomLogin;
